var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.componentClass,on:{"click":_vm.listener}},[_c('div',{class:`${_vm.componentClass}__icon`},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon}})],1),_c('div',{class:`${_vm.componentClass}__title`},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }